import React from 'react';

import { useSimpleLoyaltyList } from 'api/simple';
import { InputLimitWidth } from 'components/Layout/Form';
import { FlexContainer } from 'components/Layout/common';
import Label from 'components/Text/Label';
import { FItemInputNumber, FItemSelect } from 'components/formik';
import { policyOptions } from 'containers/Audience/utils';
import { TCampaignCreatePage } from 'containers/Campaign/i18n/TModules';
import useMultiLanguageTranslation from 'hooks/useMultiLanguageTranslation';

const LoyaltyPoints: React.FC = () => {
  const { data: loyaltyList } = useSimpleLoyaltyList();

  const fieldPath = 'filters.loyalty_points_balance.criteria';

  const options = loyaltyList?.map(program => ({
    label: program.name,
    value: String(program.id)
  }));

  const { t } = useMultiLanguageTranslation();

  return (
    <>
      <FlexContainer>
        <InputLimitWidth>
          <FItemSelect
            name={`${fieldPath}.policy`}
            placeholder={t(
              `${TCampaignCreatePage}.CampaignSelectAudience.AudienceFilters.LoyaltyFilter.Includes`
            )}
            options={policyOptions}
          />
        </InputLimitWidth>
      </FlexContainer>
      <Label bold style={{ display: 'inline-block', marginBottom: 8 }}>
        {t(
          `${TCampaignCreatePage}.CampaignSelectAudience.AudienceFilters.LoyaltyFilter.UsersWithPointsBalance`
        )}
      </Label>
      <div style={{ flex: '1 1 auto', display: 'flex' }}>
        <FItemSelect
          name={`${fieldPath}.eq`}
          aria-label="Select loyalty program"
          placeholder={t(
            `${TCampaignCreatePage}.CampaignSelectAudience.AudienceFilters.LoyaltyFilter.SelectLoyaltyProgramPlaceholder`
          )}
          options={options}
        />
        <Label style={{ margin: '0 0.5rem' }} bold>
          {t(`${TCampaignCreatePage}.CampaignSelectAudience.AudienceFilters.LoyaltyFilter.From`)}
        </Label>
        <FItemInputNumber
          name={`${fieldPath}.gteq`}
          aria-label={t(
            `${TCampaignCreatePage}.CampaignSelectAudience.AudienceFilters.LoyaltyFilter.PointsBalanceFrom`
          )}
          min={0}
          step={1}
        />
        <Label style={{ margin: '0 0.5rem' }} bold>
          {t(`${TCampaignCreatePage}.CampaignSelectAudience.AudienceFilters.LoyaltyFilter.To`)}
        </Label>
        <FItemInputNumber
          name={`${fieldPath}.lteq`}
          aria-label={t(
            `${TCampaignCreatePage}.CampaignSelectAudience.AudienceFilters.LoyaltyFilter.PointsBalanceTo`
          )}
          min={0}
          step={1}
        />
      </div>
    </>
  );
};

export default LoyaltyPoints;
